var _rect, _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    rx: 60,
    fill: "#4848D6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78.3494 25.5151C78.8573 22.5108 77.4416 17.572 73.0648 15.7889C68.688 14.0057 63.5439 15.3242 62.4848 19.0417C61.1124 23.8724 64.8083 27.1037 67.7694 28.768C71.8977 31.0915 77.7118 29.3299 78.3494 25.5151Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2975 24.5641L39.7039 38.3969C39.1635 38.8184 38.9474 39.5317 39.1635 40.1801C40.1145 43.1736 42.2543 45.5511 44.5454 46.4697C45.0965 46.6858 45.7125 46.5886 46.1664 46.2103C50.3271 42.8062 56.1088 37.9755 63.2305 34.7982C63.8897 34.5064 64.2896 33.8148 64.1923 33.1015C63.7168 29.2975 61.7175 26.4445 59.2968 24.5533C58.7132 24.0886 57.8811 24.0994 57.2975 24.5533V24.5641Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4229 39.2615C57.8811 42.1253 58.9618 46.5453 59.0807 49.3876C59.1023 49.8631 59.4049 50.2845 59.8588 50.4466C61.1556 50.8897 62.4848 50.8033 63.317 50.5655C63.7817 50.4358 64.1059 50.0468 64.1707 49.5713C64.7327 45.443 63.0792 38.3321 56.2384 35.7709C55.6441 35.5439 54.974 35.8357 54.7255 36.4301L54.0987 37.9214C53.9041 38.3861 54.023 38.9481 54.4121 39.2723L54.4229 39.2615Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M85.871 56.0554C73.3566 54.2074 43.0648 52.5432 30.853 54.7262C30.3343 54.8234 29.8804 55.1693 29.675 55.6664C27.665 60.4214 27.9027 65.2413 28.1945 67.6621C28.3026 68.5374 29.1023 69.1642 29.9884 69.067C47.0958 67.1325 72.1894 65.3386 85.0821 65.8681C85.6549 65.8897 86.206 65.6196 86.5194 65.1332C87.9135 62.907 88.4322 59.4812 87.0922 56.9308C86.8436 56.4661 86.4006 56.1419 85.8818 56.0554H85.871Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3969 70.8285C70.871 70.1909 49.1923 72.0281 36.9481 74.5461C35.8674 74.773 35.3379 75.9834 35.889 76.9344C41.152 86.0662 46.415 99.6505 48.036 103.952C48.3278 104.73 49.1599 105.151 49.9596 104.946C65.9863 100.796 74.3941 98.6995 81.8941 97.554C82.6397 97.4351 83.2125 96.8191 83.2557 96.0626C83.6772 89.157 83.4286 80.0144 82.8991 72.3198C82.8451 71.5093 82.1967 70.8717 81.3861 70.8177L81.3969 70.8285Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.1dcd1eaba009aef88d586fe8c3ace2d0.svg";
export { ForwardRef as ReactComponent };